import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllExpense(page, size, search) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Expense,
      queryString: `Page=${page}&Size=${size}&search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async getExpense() {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Expense,
      action: "GetExpense"
    });
    return await firstValueFrom(observable);
  }

  async createExpense(name, kindId,mainExpenseId) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Expense
    }, {
      name: name,
      kindId: kindId,
      mainExpenseId:mainExpenseId
    });
    return await firstValueFrom(observable);
  }

  async updateExpense(id,name, kindId,mainExpenseId) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Expense
    }, {
      id:id,
      name: name,
      kindId: kindId,
      mainExpenseId:mainExpenseId
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
